import { html } from "uhtml";
import { locales } from "../../models/locales.js";
import { safeHref } from "../../models/safe-href.js";

/**
 * The buy link, if it is a web URL. As in the EPUB reader, a same-origin
 * link carries the tracking device id (the `s` parameter), so that a
 * purchase can be tied to the reading session.
 */
function buyHref(buyLink, trackerService) {
	const href = safeHref(buyLink);
	if (!href || !trackerService) return href;
	return trackerService.appendDeviceId(href, true);
}

export function bookInfoPage(locale, bookInfo, trackerService) {
	const buyLink = buyHref(bookInfo.buyLink, trackerService);
	return html`<div class="bookinfo-wrapper">
        <!--close button-->
        <h2>About this Book</h2>
        <dl>
          ${bookInfoTemplate("bookinfo-title", bookInfo.title, "Title")}
          ${
						bookInfo.author
							? bookInfoTemplate("bookinfo-author", bookInfo.author, "Author")
							: empty()
					}
          ${bookInfoTemplate(
						"bookinfo-publisher",
						bookInfo.publisher,
						locales.bookInfoPublisher[locale],
					)}
          ${
						bookInfo.isbn
							? bookInfoTemplate(
									"bookinfo-isbn",
									bookInfo.isbn,
									locales.bookInfoIsbn[locale],
								)
							: empty()
					}
          ${
						bookInfo.genre
							? bookInfoTemplate(
									"bookinfo-genre",
									bookInfo.genre,
									locales.bookInfoGenre[locale],
								)
							: empty()
					}
          ${
						bookInfo.publicationDate
							? html`<dt>${locales.bookInfoDate[locale]}</dt>
                <dd class="bookinfo-date">
                  ${
										bookInfo.publicationDate
										// dateTimeLocale(bookInfo.publicationDate, locale)
									}
                </dd>`
							: empty()
					}
          ${
						buyLink
							? bookInfoBuyButton(
									"bookinfo-buy",
									"buy-button",
									buyLink,
									locales.bookInfoBuy[locale],
								)
							: empty()
					}
          ${
						bookInfo.shareLink
							? bookInfoShareButton(
									"bookinfo-share",
									"share-button",
									locales.bookInfoShare[locale],
								)
							: empty()
					}
        </dl>

        <jb-close-button class="about-this-book">

        <button
          type="button"
          data-type="close-dialog"
          tabindex="0"
        >
          ${locales.closeIcon[locale]}
        </button>
        </jb-close-button>
      </div>`;
}

/** Markup for elements in About this book */
const bookInfoTemplate = (divClassName, divContent, preText = "") =>
	html`<dt>${preText}</dt>
    <dd class="${divClassName}">${divContent}</dd> `;

function empty() {
	return html`<span></span>`;
}

/**
 * Markup for About this book links. They stay in the tab order: the PDF
 * reader has no toolbar buy link, so this is the only way to reach a buy
 * action from the keyboard.
 */
const bookInfoBuyButton = (buttonId, buttonClass, href, buttonLabel) => html`
  <a
    id="${buttonId}"
    class="${buttonClass}"
    href="${href}"
    target="_blank"
    rel="noopener"
    >${buttonLabel}</a
  >
`;

/** Markup for Share button */
const bookInfoShareButton = (buttonId, buttonClass, buttonLabel) => html`
  <button id="${buttonId}" class="${buttonClass}">
    ${buttonLabel}
  </button>
`;
